import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, Loading } from 'ionic-angular';
import * as page from '../pages';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {ecomBadgesApi} from '../../api/ecom/ecomApi';
import {ApiConfig} from '../../shared/api-config.service'
import {AppConfig} from '../../shared/app-config.service'
import {LoggerService} from '../../shared/logger.service'
import { Storage } from '@ionic/storage';

@Component({
	selector: 'page-badge',
	templateUrl: 'badge.html',
	providers: [ecomBadgesApi, ApiConfig, LoggerService,AppConfig]
})
export class BadgePage {

	userId:number;
	userBadge: any = [];
	offlineBadge: any = [];
	zeroData: boolean = false;
	displayData: boolean = false;
	connection: boolean = false;
	imageContainer: string;
	userName: string;
	lastSyncDate: string = "";
	organisationLogo: string = "";
	hasNetworkConnection: boolean;
	hasInternetAccess: boolean;
	status: string;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
      	private ecomBadgesApi: ecomBadgesApi, 
      	private loadingCtrl: LoadingController, 
		private alertCtrl: AlertController,
		private log: LoggerService,
      	private storage: Storage,
		  private apiConfig: ApiConfig
		) {
			this.lastSyncDate = localStorage.getItem("lastSyncDate") == this.getDate() ? "<span class='active'>Pass is valid for today: "+ this.getDate() +"</span>" : "<span class='expired'>Pass has expired and no longer valid</span>";
			this.navParams.get('id');
			this.storage.get('name').then(data => {
				this.userName = data;
			});
			this.storage.get('userId').then(data => {
				this.userId = Number(data);
			});
			this.storage.get("OrganisationLogo").then(data => {
				if (data != null && data != undefined){
					this.organisationLogo = data;
				}
			});
			this.imageContainer = apiConfig.BadgeContainer;
		}

		getDate(){
			var today = new Date();
			var dd = today.getDate();
	
			var mm = today.getMonth()+1; 
			var yyyy = today.getFullYear();
	
			var dds = "";
			var mms = "";
			var yyyys = "";
	
			if (dd < 10) 
				dds = '0'+dd;
			else
				dds = dd.toString();
	
			if (mm < 10) 
				mms = '0'+mm;
				else
				mms = mm.toString();
	
			yyyys = yyyy.toString();
	
			return dds+"/"+mms+"/"+yyyys;
		}

	ionViewDidLoad() {
			console.log("app offline");
		this.storage.get('OfflineBadges').then((val) => {	
				console.log("val = " + val);
			if(val != null) {
				for (let i = 0; i < val.length; i++) {
					if (val[i].id === this.navParams.data) {
							console.log("badge " + i + " - " + val[i]);
						this.userBadge[0] = val[i];
					}
				}
				this.displayData = true;
			}
			else{	
				this.zeroData = true;				
			}		
		});	
	}
}


// WEBPACK FOOTER //
// ./src/pages/badge/badge.ts